import { render, staticRenderFns } from "./wangEditReadOnly.vue?vue&type=template&id=85eea096&scoped=true&"
import script from "./wangEditReadOnly.vue?vue&type=script&lang=js&"
export * from "./wangEditReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./wangEditReadOnly.vue?vue&type=style&index=0&id=85eea096&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eea096",
  null
  
)

export default component.exports